<template>
  <div
    class="favorites"
    :class="{
      'favorites__factory': active === 'factories'
    }"
  >
    <BreadCrumb class="favorites__breadcrumb">
      <BreadCrumbItem to="/">
        Home
      </BreadCrumbItem>
      <BreadCrumbItem>My Favorites</BreadCrumbItem>
      <BreadCrumbItem>
        {{ active === 'products' ? 'Favorite Products' : 'Favorite Factories' }}
      </BreadCrumbItem>
    </BreadCrumb>
    <PageContainer class="favorites__header">
      <Tabs
        class="favorites-tabs"
        v-model:active="active"
        @change="onTabChange"
      >
        <Tab name="products">
          <template #title>
            Favorite Products
          </template>
        </Tab>
        <Tab name="factories">
          <template #title>
            Favorite Factories
          </template>
        </Tab>
      </Tabs>
      <div class="favorites__search" />
    </PageContainer>
    <PageContainer class="favorites__content">
      <RouterView />
    </PageContainer>
  </div>
</template>

<script setup>
import { Tab, Tabs } from '@/components/Tab'
import { PageContainer } from '@/components/PageLayout'
import BreadCrumb from '@/components/BreadCrumb/BreadCrumb.vue'
import BreadCrumbItem from '@/components/BreadCrumb/BreadCrumbItem.vue'

const route = useRoute()
const router = useRouter()

const active = ref('products')

watch(() => route.name, (name) => {
  if (name === 'favoritesFactories') {
    active.value = 'factories'
  } else {
    active.value = 'products'
  }
}, {
  immediate: true
})

const onTabChange = (val) => {
  if (val === 'products') {
    router.replace('/favorites/products')
  } else if (val === 'factories') {
    router.replace('/favorites/factories')
  }
}
</script>

<style lang="less" scoped>
.favorites {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__factory {
    @media (min-width: 768px) {
      background-color: #F8F8F8;
    }
  }

  &__breadcrumb {
    background-color: #FFFFFF;
  }

  &__header {
    background-color: #FFFFFF;

    :deep(.page-container__content) {
      position: relative;
    }
  }

  &-tabs {
    padding-top: 24px;

    :deep(.tabs-nav) {
      border: none;
    }

    :deep(.tabs-nav__item) {
      padding: 0 12px 20px;
      &:first-child {
        padding-left: 0;
      }
      &:nth-last-child(2) {
        padding-right: 0;
      }
    }

    :deep(.tabs-content) {
      padding: 0;
    }
  }

  &__search {
    position: absolute;
    top: 16px;
    right: 24px;
    width: 286px;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;

    :deep(.page-container__content) {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
